<script lang="ts"></script>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useConditionalSlots } from 'composables/useConditionalSlots';

export interface CardSlots {
  header(props?: {}): any;
  default(props?: {}): any;
  footer(props?: {}): any;
  [key: string]: ((props?: {}) => any) | undefined;
}

export interface CardProps {
  as?: any;
  color?: string;
  variant?: string;
}

const props = withDefaults(defineProps<CardProps>(), {
  as: 'div',
  color: 'neutral',
  variant: 'soft'
});

const classes = computed(() => [
  'e-card',
  props.color && `e-card-color-${props.color}`,
  props.variant && `e-card-variant-${props.variant}`
]);

const elRef = ref<HTMLElement | null>(null);

const {
  header: hasHeader,
  default: hasDefault,
  footer: hasFooter
} = useConditionalSlots<CardSlots>(elRef, ['header', 'default', 'footer']);
</script>

<template>
  <component
    :is="props.as"
    ref="elRef"
    :class="classes"
  >
    <div v-if="hasHeader">
      <slot name="header" />
    </div>

    <div v-if="hasDefault">
      <slot />
    </div>

    <div v-if="hasFooter">
      <slot name="footer" />
    </div>
  </component>
</template>
